// Brands allowed to be created
export const ALLOWEDBRANDS = ['CON', 'GDY', 'MCL', 'PRL']
